import { TextFieldProps } from '@mui/material/TextField';
import { TextField } from 'src/components/atoms';

export const Textarea = ({ inputProps, ...props }: TextFieldProps) => (
  <TextField
    multiline
    inputProps={{ sx: { minHeight: '7.5rem !important' }, maxLength: 500, ...inputProps }}
    {...props}
  />
);
